<div *ngIf="isVisible" class="modal-overlay" (click)="onOverlayClick()">
  <div class="custom-modal" (click)="onModalClick($event)">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header bg-danger text-white">
        <h4 class="modal-title">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          Confirm Pre-Alert Deletion
        </h4>
        <button type="button" class="btn-close btn-close-white" (click)="cancel()"></button>
      </div>
      
      <!-- Modal Body -->
      <div class="modal-body">
        <div class="alert alert-danger" role="alert">
          <h5 class="alert-heading">
            <i class="bi bi-exclamation-triangle me-2"></i>
            <strong>Warning!</strong>
          </h5>
          <p class="mb-3">This action will permanently delete the following data and <strong>cannot be undone:</strong></p>
          
          <ul class="mb-3">
            <li><strong>Pre-Alert:</strong> {{ preAlert.ladingBill }}</li>
            <li><strong>All associated ShopeeOrders</strong> (cartons)</li>
            <li><strong>All associated Parcels</strong></li>
            <li><strong>All carton mappings</strong></li>
            <li><strong>Export history</strong> for this pre-alert</li>
          </ul>
          
          <p class="mb-0 fw-bold text-danger">
            <i class="bi bi-exclamation-triangle me-1"></i>
            This action cannot be undone!
          </p>
        </div>

        <!-- Pre-Alert Summary -->
        <div class="card mb-4">
          <div class="card-header">
            <h6 class="mb-0">
              <i class="bi bi-file-earmark-text me-2"></i>
              Pre-Alert to be deleted
            </h6>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label text-muted">Lading Bill</label>
                <div class="fw-bold text-primary">{{ preAlert.ladingBill }}</div>
              </div>
              <div class="col-md-6">
                <label class="form-label text-muted">Transport Company</label>
                <div>{{ preAlert.transportCompany }}</div>
              </div>
              <div class="col-md-6">
                <label class="form-label text-muted">Carton Count</label>
                <div>{{ preAlert.cartonCount }}</div>
              </div>
              <div class="col-md-6">
                <label class="form-label text-muted">Status</label>
                <div>
                  <span class="badge bg-secondary">{{ preAlert.status }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Confirmation Input -->
        <div class="form-group">
          <label for="confirmationInput" class="form-label fw-bold">
            <i class="bi bi-shield-exclamation me-2"></i>
            Type the lading bill number to confirm deletion:
          </label>
          <input 
            type="text" 
            id="confirmationInput"
            class="form-control form-control-lg"
            [(ngModel)]="confirmationText"
            [placeholder]="preAlert.ladingBill"
            [class.is-valid]="isValid && confirmationText.length > 0"
            [class.is-invalid]="confirmationText.length > 0 && !isValid"
            autocomplete="off">
          <div class="invalid-feedback" *ngIf="confirmationText.length > 0 && !isValid">
            The entered text does not match the lading bill number.
          </div>
          <div class="valid-feedback" *ngIf="isValid && confirmationText.length > 0">
            Confirmation text matches. You can proceed with deletion.
          </div>
        </div>
      </div>
      
      <!-- Modal Footer -->
      <div class="modal-footer">
        <button 
          type="button" 
          class="btn btn-secondary me-2" 
          (click)="cancel()">
          <i class="bi bi-x-circle me-1"></i>
          Cancel
        </button>
        <button 
          type="button" 
          class="btn btn-danger"
          [disabled]="!isValid"
          [class.btn-outline-danger]="!isValid"
          (click)="onConfirm()">
          <i class="bi bi-trash-fill me-1"></i>
          <span *ngIf="isValid">Delete Everything</span>
          <span *ngIf="!isValid">Enter Confirmation Text</span>
        </button>
      </div>
    </div>
  </div>
</div>